import { QuestionRequest } from "./ChecklistRequests";
import { UpsertQuestionsReponse } from "./ChecklistResponses";
import HttpClient from "../../../core/api/httpClient";
import { Category } from "../model/ChecklistDtos";


const baseUrl = '/api/questions';
const getByIdUrl = (id: number): string => (`${baseUrl}/${id}`);

export default class ChecklistQuestionsApi {

    static async addQuestion( questionsRequests: QuestionRequest[]): Promise<{ succeeded: boolean }> {
        const response = await HttpClient.post(baseUrl, {
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(questionsRequests),
        });
        return {
            succeeded: response.ok
        }
    }

    static async editQuestion( id: number, questionsRequests: QuestionRequest): Promise<{ succeeded: boolean }> {
        const response = await HttpClient.put(getByIdUrl(id), {
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(questionsRequests),
        });
        return {
            succeeded: response.ok
        }
    }

    static async deleteQuestion( id: number): Promise<{ succeeded: boolean }> {
        const  response = await HttpClient.delete(getByIdUrl(id));
        return {
            succeeded: response.ok
        }
    }

    static async upsertQuestions( checklistId: number, questionsRequests: QuestionRequest[]): Promise<UpsertQuestionsReponse> {
        try {
            const response = await HttpClient.put(`${baseUrl}/upsert/${checklistId}`, {
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(questionsRequests),
            });

            const result = await response.json();
            return response.ok
                ? { success: true, questions: result.questions }
                : { success: false, message: result.message || "Failed to upsert questions." };
        } catch (error) {
            console.error("Error in upsertQuestions:", error);
            return { success: false, message: "An error occurred while upserting questions." };
        }
    }

    static async getCategories(checklistId: number): Promise<Category[]> {
        try {
            const response = await HttpClient.get(`${baseUrl}/categories/${checklistId}`);
            const categories = await response.json();

            return categories;
        }
        catch (error) {
            return [];
        }
    }
}
